import React, { useEffect, useState } from "react";
import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import {
  developmentTaskStatus,
  DigitalServiceOptions,
  DigitalServiceOptionsDrop,
  projectStatus,
  RelatedToOption,
  resaonOtption,
} from "utils/common-options";
import moment from "moment";
import { Link } from "react-router-dom";
import configure from "configure";
import Swal from "sweetalert2";
import sideImg from "../../../assets/images/profile.png";
import indiaFlag from "../../../assets/images/flags/india.png";
import ukFlag from "../../../assets/images/flags/uk.png";
import {
  calculateTimeDifference,
  getInitials,
  trimProjectName,
} from "utils/common-helpers";
import bug from "../../../assets/images/bug.png";

// export const generalDashboardColumns = (
//   handleEditTask,
//   onDelete,
//   handleChangeStatus,
//   onManagePlan,
//   handleAddHour,
//   followChangeStatus,
//   onAddTask
// ) => [
//     {
//       Header: "Id",
//       accessor: "id",
//       isInfoIcon: false,
//       isShortIcon: true,
//       className: "dg_id",
//       Cell: (cellProps) => {
//         const [status, setStatus] = useState(cellProps?.row?.original?.plan_day);
//         useEffect(() => {
//           setStatus(cellProps?.row?.original?.plan_day);
//         }, [cellProps?.row?.original]);
//         return (
//           <div className="d-flex justify-content-center align-items-center gap-1">
//             <span>
//               <a
//                 className="color-grey me-1"
//                 title="Plan My Day"
//                 onClick={() => {
//                   onManagePlan(
//                     cellProps.row.original?.id,
//                     cellProps?.row?.original?.plan_day == 0 ? 1 : 0,
//                     cellProps?.row?.original?.type
//                   );
//                   setStatus(status == 0 ? 1 : 0);
//                 }}
//               >
//                 <i
//                   className={`${status == 1
//                     ? "bi bi-brightness-high-fill color-orange"
//                     : "bi bi-brightness-high "
//                     } fs-4`}
//                 ></i>
//               </a>
//             </span>
//             <span>{cellProps.row.original.id}</span>
//           </div>
//         );
//       },
//     },
//     {
//       Header: "Status",
//       accessor: "status",
//       isInfoIcon: false,
//       isShortIcon: true,
//       className: "dg-com-status text-center",
//       Cell: (cellProps) => {
//         const [isChecked, setIsChecked] = useState(
//           cellProps.row.original.checked || false
//         );
//         const handleCheckboxChange = async (e, id) => {
//           const checked = e.target.checked;
//           setIsChecked(checked);
//           const userConfirmed = await Swal.fire({
//             title: "Are you sure?",
//             text: `${cellProps.row.original.added_by != localStorage.getItem("auth_id")
//               ? "You want to Mark as complete ?"
//               : "You have Reviewed this Activity before completing?"
//               }`,
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonText: "Yes, change it!",
//             cancelButtonText: "No, cancel",
//           });

//           if (userConfirmed.isConfirmed) {
//             handleChangeStatus(
//               e,
//               cellProps.row.original.id,
//               cellProps?.row?.original?.related_to,
//               cellProps?.row?.original?.related_id,
//               cellProps.row.original.added_by != localStorage.getItem("auth_id")
//                 ? "complete"
//                 : "",
//               cellProps.row.original.added_by == localStorage.getItem("auth_id"),
//               cellProps.row.original
//             );
//             setIsChecked(false);
//           } else {
//             setIsChecked(false);
//           }
//         };

//         const assignee = cellProps?.row?.original?.assigned?.split(",");

//         return (
//           <div className="d-flex align-items-center gap-3 justify-content-center">
//             <span>
//               {moment(cellProps?.row?.original?.created_at).format("DD-MM-YYYY")}
//             </span>
//             {cellProps.row.original.type === 1 ? (
//               <img
//                 src={`${cellProps?.row?.original?.img
//                   ? `${configure?.imgUrl}${cellProps?.row?.original?.img}`
//                   : sideImg
//                   }`}
//                 alt=""
//                 className="img-fluid assignee-img"
//                 title={cellProps?.row?.original?.added_by_name}
//               />
//             ) : (
//               <img
//                 src={`${cellProps?.row?.original?.avatar
//                   ? `${configure?.imgUrl}${cellProps?.row?.original?.avatar}`
//                   : sideImg
//                   }`}
//                 alt=""
//                 className="img-fluid assignee-img"
//                 title={cellProps?.row?.original?.added_by_name}
//               />
//             )}
//             <div className="text-end" id="customCheckbox">
//               {cellProps.row.original.type === 1 ? (
//                 <>
//                   {cellProps.row.original?.status != "mark-completed" ||
//                     cellProps.row.original.added_by ==
//                     localStorage.getItem("auth_id") ? (
//                     <>
//                       {assignee?.length > 1 &&
//                         cellProps.row.original.added_by ==
//                         localStorage.getItem("auth_id") ? (
//                         <>
//                           {cellProps.row.original?.status == "mark-completed" ? (
//                             <input
//                               type="checkbox"
//                               className="form-check-input custom-checkbox  mt-2im general-status"
//                               id={`customCheck-${cellProps.row.id}`}
//                               value="complete"
//                               checked={isChecked}
//                               onChange={(e) =>
//                                 handleCheckboxChange(e, cellProps.row.original.id)
//                               }
//                             />
//                           ) : null}
//                         </>
//                       ) : (
//                         <input
//                           type="checkbox"
//                           className="form-check-input custom-checkbox  mt-2im general-status"
//                           id={`customCheck-${cellProps.row.id}`}
//                           value="complete"
//                           checked={isChecked}
//                           onChange={(e) =>
//                             handleCheckboxChange(e, cellProps.row.original.id)
//                           }
//                         />
//                       )}
//                     </>
//                   ) : null}
//                 </>
//               ) : cellProps.row.original.type === 2 ? (
//                 <>
//                   <div className="text-center">
//                     <button
//                       className="btn btn-outline-secondary btn-sm"
//                       onClick={() =>
//                         followChangeStatus({
//                           user_id: localStorage.getItem("auth_id"),
//                           followup_id: cellProps.row.original.id,
//                         })
//                       }
//                     >
//                       <i className="fas fa-check"></i>
//                     </button>
//                   </div>
//                 </>
//               ) : null}
//             </div>
//           </div>
//         );
//       },
//     },
//     {
//       Header: "Related",
//       accessor: "related",
//       isInfoIcon: false,
//       isShortIcon: false,
//       className: "dg-related",
//       Cell: (cellProps) => {
//         let priorty;
//         if (cellProps.row.original?.priorty == "high") {
//           priorty = <i title="High priority" className="bx bxs-hot icon-hot"></i>;
//         } else if (cellProps.row.original?.priorty == "medium") {
//           priorty = (
//             <i title="Medium priority" className="bx bxs-flame icon-flame"></i>
//           );
//         } else if (cellProps.row.original?.priorty == "low") {
//           priorty = <i title="Low priority" className="bx bxs-sun icon-sun"></i>;
//         }
//         return (
//           <>
//             {priorty}
//             <a
//               className={`fs-3 ms-2 ${RelatedToOption?.find(
//                 (obj) => obj?.value == cellProps.row.original.related
//               )?.color
//                 }`}
//               title={`${RelatedToOption?.find(
//                 (obj) => obj?.value == cellProps.row.original.related
//               )?.label
//                 }`}
//             >
//               <i
//                 className={`${RelatedToOption?.find(
//                   (obj) => obj?.value == cellProps.row.original.related
//                 )?.icon
//                   }`}
//               ></i>
//             </a>
//           </>
//         );
//       },
//     },
//     {
//       Header: "Task Name",
//       accessor: "title",
//       isInfoIcon: false,
//       isShortIcon: true,
//       className: "dg_task_name",
//       Cell: (cellProps) => {
//         const subTasks = cellProps.row?.original?.subtasks;
//         const isAssignee = subTasks?.filter(
//           (obj) => obj?.assign == localStorage.getItem("auth_id")
//         );
//         const shownSubTask =
//           isAssignee != undefined && isAssignee?.length != 0 ? isAssignee : null;
//         return (
//           <div>
//             <strong>
//               {" "}
//               {shownSubTask?.length != 0 && shownSubTask != null ? (
//                 <i className="bx bx-subdirectory-right fs-5"></i>
//               ) : null}
//               {` ${cellProps?.row?.original?.related_name ||
//                 cellProps?.row?.original?.related_to != null
//                 ? `${cellProps?.row?.original?.related_name ||
//                 cellProps?.row?.original?.related_to
//                 } - `
//                 : ""
//                 }`}
//             </strong>{" "}
//             {cellProps?.row?.original?.title}
//             <div className="ms-4">
//               {shownSubTask?.length != 0 && shownSubTask != null ? (
//                 <>
//                   {shownSubTask?.map((obj, i) => {
//                     return (
//                       <p
//                         className={`mb-0 subtask-title ${obj?.status == 1
//                           ? "text-decoration-line-through text-success"
//                           : ""
//                           }`}
//                         key={i}
//                       >
//                         - {obj?.title} :{" "}
//                         <span className="fw-bold">{moment(obj?.enddate).format("DD-MM-YYYY")}</span>
//                       </p>
//                     );
//                   })}
//                 </>
//               ) : null}
//             </div>
//           </div>
//         );
//       },
//     },
//     {
//       Header: "End Date",
//       accessor: "enddate",
//       isInfoIcon: false,
//       isShortIcon: true,
//       className: "dg_end_date",
//       Cell: (cellProps) => {
//         return (
//           <div>
//             {cellProps?.row?.original?.enddate != null
//               ? moment(cellProps?.row?.original?.enddate)?.format("DD-MM-YYYY")
//               : "-"}
//           </div>
//         );
//       },
//     },
//     {
//       Header: "Spent Hrs",
//       accessor: "spent_hours",
//       isInfoIcon: false,
//       isShortIcon: true,
//       className: "dg_last_update",
//       Cell: (cellProps) => {
//         return (
//           <div className="">{cellProps?.row?.original?.spent_hours || "-"}</div>
//         );
//       },
//     },
//     {
//       Header: "Action",
//       accessor: "action",
//       className: "activity-action",
//       Cell: (cellProps) => {
//         return (
//           <>
//             {cellProps?.row?.original?.type == 1 ? (
//               // <div className="d-flex justify-content-center">
//               //   <a
//               //     className="btn btn-sm btn-outline-secondary me-1"
//               //     title="View Activity"
//               //     onClick={() => handleEditTask(cellProps?.row?.original, "view")}
//               //   >
//               //     <i className="fas fa-eye "></i>
//               //   </a>

//               //   <a
//               //     title="Add Hours"
//               //     className="btn btn-sm btn-outline-secondary me-1"
//               //     onClick={() =>
//               //       handleAddHour(
//               //         cellProps.row.original.id,
//               //         cellProps?.row?.original?.related_to,
//               //         cellProps?.row?.original?.related_id,
//               //         cellProps.row.original
//               //       )
//               //     }
//               //   >
//               //     <i className="bi bi-alarm-fill"></i>
//               //   </a>
//               //   <UncontrolledDropdown
//               //     className="dropdown"
//               //     style={{ width: "29px" }}
//               //   >
//               //     <DropdownToggle
//               //       className="btn btn-sm btn-outline-secondary w-100"
//               //       color="white"
//               //     >
//               //       <i className="mdi mdi-dots-horizontal"></i>
//               //     </DropdownToggle>
//               //     <DropdownMenu className="dropdown-menu-end">
//               //       <a
//               //         className="dropdown-item"
//               //         title="Edit Activity"
//               //         onClick={() =>
//               //           handleEditTask(cellProps?.row?.original, "edit")
//               //         }
//               //       >
//               //         <i className="fas fa-pen pr-10"></i>
//               //         Edit Activity
//               //       </a>
//               //       <a
//               //         title="Delete Activity"
//               //         className="dropdown-item"
//               //         onClick={() => onDelete(cellProps?.row?.original?.id)}
//               //       >
//               //         <i className="fas fa-trash-alt text-danger pr-10"></i>{" "}
//               //         Delete Activity
//               //       </a>
//               //     </DropdownMenu>
//               //   </UncontrolledDropdown>
//               // </div>
//               <div className="d-flex justify-content-center">
//                 <a
//                   className="btn btn-sm btn-outline-secondary me-1"
//                   title="Edit Activity"
//                   onClick={() =>
//                     handleEditTask(cellProps?.row?.original, "edit")
//                   }
//                 >
//                   <i className="fas fa-pen "></i>
//                 </a>

//                 <a
//                   title="Add Hours"
//                   className="btn btn-sm btn-outline-secondary me-1"
//                   onClick={() => {
//                     console.log(
//                       "CellProps.row.original: ",
//                       cellProps.row.original
//                     )
//                     handleAddHour(
//                       cellProps.row.original.id,
//                       cellProps?.row?.original?.related_to,
//                       cellProps?.row?.original?.related_id,
//                       cellProps.row.original
//                     )
//                   }}
//                 >
//                   <i className="bi bi-alarm-fill"></i>
//                 </a>
//                 <UncontrolledDropdown
//                   className="dropdown"
//                   style={{ width: "29px" }}
//                 >
//                   <DropdownToggle
//                     className="btn btn-sm btn-outline-secondary w-100"
//                     color="white"
//                   >
//                     <i className="mdi mdi-dots-horizontal"></i>
//                   </DropdownToggle>
//                   <DropdownMenu className="dropdown-menu-end">
//                     <a
//                       className="dropdown-item"
//                       title="View Activity"
//                       onClick={() => handleEditTask(cellProps?.row?.original, "view")}
//                     >
//                       <i className="fas fa-eye pr-10"></i> View Activity
//                     </a>
//                     <a
//                       title="Delete Activity"
//                       className="dropdown-item"
//                       onClick={() => onDelete(cellProps?.row?.original?.id)}
//                     >
//                       <i className="fas fa-trash-alt text-danger pr-10"></i>{" "}
//                       Delete Activity
//                     </a>
//                   </DropdownMenu>
//                 </UncontrolledDropdown>
//               </div>
//             ) : (
//               <div className="d-flex ">
//                 <Link
//                   title="view lead"
//                   target="_blank"
//                   className="btn btn-sm btn-outline-secondary me-1"
//                   to={`${configure.appUrl}sales/edit-lead/${cellProps.row.original?.related_id}`}
//                 >
//                   <i className="fas fa-arrow-right"></i>
//                 </Link>
//                 <a
//                   title="Add Task"
//                   className="btn btn-sm btn-outline-secondary me-1 "
//                   onClick={() =>
//                     onAddTask(
//                       cellProps.row.original?.related_id,
//                       cellProps?.row?.original?.related_to,
//                       cellProps?.row?.original?.related_id
//                     )
//                   }
//                 >
//                   <i className="fas fa-clipboard-list"></i>
//                 </a>
//               </div>
//             )}
//           </>
//         );
//       },
//     },
//   ];

// export const generalDashboardColumns = (
//   handleEditTask,
//   onDelete,
//   handleChangeStatus,
//   onManagePlan,
//   handleAddHour,
//   followChangeStatus,
//   onAddTask,
//   handleApprove
// ) => [
//   {
//     Header: "Id",
//     accessor: "id",
//     isInfoIcon: false,
//     isShortIcon: true,
//     className: "dg_id",
//     Cell: cellProps => {
//       const [status, setStatus] = useState(cellProps?.row?.original?.plan_day)
//       useEffect(() => {
//         setStatus(cellProps?.row?.original?.plan_day)
//       }, [cellProps?.row?.original])
//       return (
//         <div className="d-flex justify-content-center align-items-center gap-1">
//           <span>
//             {cellProps?.row?.original.type != 3 ? (
//               <a
//                 className="color-grey me-1"
//                 title="Plan My Day"
//                 onClick={() => {
//                   onManagePlan(
//                     cellProps.row.original?.id,
//                     cellProps?.row?.original?.plan_day == 0 ? 1 : 0,
//                     cellProps?.row?.original?.type
//                   )
//                   setStatus(status == 0 ? 1 : 0)
//                 }}
//               >
//                 <i
//                   className={`${
//                     status == 1
//                       ? "bi bi-brightness-high-fill color-orange"
//                       : "bi bi-brightness-high "
//                   } fs-4`}
//                 ></i>
//               </a>
//             ) : null}
//           </span>
//           <span>{cellProps.row.original.id}</span>
//         </div>
//       )
//     },
//   },
//   {
//     Header: "Status",
//     accessor: "status",
//     isInfoIcon: false,
//     isShortIcon: true,
//     className: "dg-com-status text-center",
//     Cell: cellProps => {
//       const [isChecked, setIsChecked] = useState(
//         cellProps.row.original.checked || false
//       )
//       const handleCheckboxChange = async (e, id) => {
//         const checked = e.target.checked
//         setIsChecked(checked)
//         const userConfirmed = await Swal.fire({
//           title: "Are you sure?",
//           text: `${
//             cellProps.row.original.added_by != localStorage.getItem("auth_id")
//               ? "You want to Mark as complete ?"
//               : "You have Reviewed this Activity before completing?"
//           }`,
//           icon: "warning",
//           showCancelButton: true,
//           confirmButtonText: "Yes, change it!",
//           cancelButtonText: "No, cancel",
//         })

//         if (userConfirmed.isConfirmed) {
//           handleChangeStatus(
//             e,
//             cellProps.row.original.id,
//             cellProps?.row?.original?.related_to,
//             cellProps?.row?.original?.related_id,
//             cellProps.row.original.added_by != localStorage.getItem("auth_id")
//               ? "complete"
//               : "",
//             cellProps.row.original.added_by == localStorage.getItem("auth_id"),
//             cellProps.row.original
//           )
//           setIsChecked(false)
//         } else {
//           setIsChecked(false)
//         }
//       }

//       const assignee = cellProps?.row?.original?.assigned?.split(",")

//       return (
//         <div className="d-flex align-items-center gap-3 justify-content-center">
//           <span>
//             {/* {moment(cellProps?.row?.original?.created_at).format("DD-MM-YYYY")} */}
//             {moment(
//               cellProps?.row?.original?.type === 1
//                 ? cellProps?.row?.original?.startdate
//                 : cellProps?.row?.original?.created_at,
//             ).format("DD-MM-YYYY")}
//           </span>
//           {cellProps.row.original.type === 1 ? (
//             <>
//               {cellProps?.row?.original?.img ? (
//                 <img
//                   src={`${configure.imgUrl}${cellProps?.row?.original?.img}`}
//                   alt=""
//                   className="img-fluid assignee-img"
//                   title={cellProps?.row?.original?.added_by_name}
//                 />
//               ) : (
//                 <div
//                   className="defualt-img "
//                   title={cellProps?.row?.original?.added_by_name}
//                 >
//                   {getInitials(cellProps?.row?.original?.added_by_name || "Z")}
//                 </div>
//               )}
//             </>
//           ) : (
//             <>
//               {cellProps?.row?.original?.avatar ? (
//                 <img
//                   src={`${
//                     cellProps?.row?.original?.avatar
//                       ? `${configure?.imgUrl}${cellProps?.row?.original?.avatar}`
//                       : sideImg
//                   }`}
//                   alt=""
//                   className="img-fluid assignee-img"
//                   title={cellProps?.row?.original?.added_by_name}
//                 />
//               ) : (
//                 <div
//                   className="defualt-img "
//                   title={cellProps?.row?.original?.added_by_name}
//                 >
//                   {getInitials(cellProps?.row?.original?.added_by_name || "Z")}
//                 </div>
//               )}
//             </>
//           )}

//           <div className="text-end" id="customCheckbox">
//             {cellProps.row.original.type === 1 ? (
//               <>
//                 {cellProps.row.original?.status != "mark-completed" ||
//                 cellProps.row.original.added_by ==
//                   localStorage.getItem("auth_id") ? (
//                   <>
//                     {assignee?.length > 1 &&
//                     cellProps.row.original.added_by ==
//                       localStorage.getItem("auth_id") ? (
//                       <>
//                         {cellProps.row.original?.status == "mark-completed" ? (
//                           <input
//                             type="checkbox"
//                             className="form-check-input custom-checkbox  mt-2im general-status"
//                             id={`customCheck-${cellProps.row.id}`}
//                             value="complete"
//                             checked={isChecked}
//                             onChange={e =>
//                               handleCheckboxChange(
//                                 e,
//                                 cellProps.row.original.id,
//                                 cellProps.row.original
//                               )
//                             }
//                           />
//                         ) : null}
//                       </>
//                     ) : (
//                       <input
//                         type="checkbox"
//                         className="form-check-input custom-checkbox  mt-2im general-status"
//                         id={`customCheck-${cellProps.row.id}`}
//                         value="complete"
//                         checked={isChecked}
//                         onChange={e =>
//                           handleCheckboxChange(e, cellProps.row.original.id)
//                         }
//                       />
//                     )}
//                   </>
//                 ) : null}
//               </>
//             ) : cellProps.row.original.type === 2 ? (
//               <>
//                 <div className="text-center">
//                   <button
//                     className="btn btn-outline-secondary btn-sm"
//                     onClick={() =>
//                       followChangeStatus({
//                         user_id: localStorage.getItem("auth_id"),
//                         followup_id: cellProps.row.original.id,
//                       })
//                     }
//                   >
//                     <i className="fas fa-check"></i>
//                   </button>
//                 </div>
//               </>
//             ) : null}
//           </div>
//         </div>
//       )
//     },
//   },
//   {
//     Header: "Related",
//     accessor: "related",
//     isInfoIcon: false,
//     isShortIcon: false,
//     className: "dg-related",
//     Cell: cellProps => {
//       let priorty
//       if (cellProps.row.original?.priorty == "high") {
//         priorty = <i title="High priority" className="bx bxs-hot icon-hot"></i>
//       } else if (cellProps.row.original?.priorty == "medium") {
//         priorty = (
//           <i title="Medium priority" className="bx bxs-flame icon-flame"></i>
//         )
//       } else if (cellProps.row.original?.priorty == "low") {
//         priorty = <i title="Low priority" className="bx bxs-sun icon-sun"></i>
//       }
//       return (
//         <>
//           {priorty}
//           {cellProps.row.original?.type == 3 ? (
//             <a className={`fs-3 ms-2`}>
//               <i className="mdi mdi-file-document-edit"></i>
//             </a>
//           ) : (
//             <a
//               className={`fs-3 ms-2 ${
//                 RelatedToOption?.find(
//                   obj => obj?.value == cellProps.row.original.related
//                 )?.color
//               }`}
//               title={`${
//                 RelatedToOption?.find(
//                   obj => obj?.value == cellProps.row.original.related
//                 )?.label
//               }`}
//             >
//               <i
//                 className={`${
//                   RelatedToOption?.find(
//                     obj => obj?.value == cellProps.row.original.related
//                   )?.icon
//                 }`}
//               ></i>
//             </a>
//           )}
//         </>
//       )
//     },
//   },
//   {
//     Header: "Task Name",
//     accessor: "title",
//     isInfoIcon: false,
//     isShortIcon: true,
//     className: "dg_task_name",
//     Cell: cellProps => {
//       const subTasks = cellProps.row?.original?.subtasks
//       const isAssignee = subTasks?.filter(
//         obj => obj?.assign == localStorage.getItem("auth_id")
//       )
//       const shownSubTask =
//         isAssignee != undefined && isAssignee?.length != 0 ? isAssignee : null
//       return (
//         <div>
//           {cellProps.row.original.type == 3 ? (
//             <div>
//               {cellProps?.row?.original?.cust_company_name ||
//                 cellProps?.row?.original?.lead_company_name ||
//                 cellProps?.row?.original?.intro_company_name}
//             </div>
//           ) : (
//             <div>
//               <strong>
//                 {" "}
//                 {shownSubTask?.length != 0 && shownSubTask != null ? (
//                   <i className="bx bx-subdirectory-right fs-5"></i>
//                 ) : null}
//                 {` ${
//                   cellProps?.row?.original?.related_name ||
//                   cellProps?.row?.original?.related_to != null
//                     ? `${
//                         cellProps?.row?.original?.related_name ||
//                         cellProps?.row?.original?.related_to
//                       } - `
//                     : ""
//                 }`}
//               </strong>{" "}
//               {cellProps?.row?.original?.title}
//               <div className="ms-4">
//                 {shownSubTask?.length != 0 && shownSubTask != null ? (
//                   <>
//                     {shownSubTask?.map((obj, i) => {
//                       return (
//                         <p
//                           className={`mb-0 subtask-title ${
//                             obj?.status == 1
//                               ? "text-decoration-line-through text-success"
//                               : ""
//                           }`}
//                           key={i}
//                         >
//                           - {obj?.title} :{" "}
//                           <span className="fw-bold">{obj?.enddate}</span>
//                         </p>
//                       )
//                     })}
//                   </>
//                 ) : null}
//               </div>
//             </div>
//           )}
//         </div>
//       )
//     },
//   },
//   {
//     Header: "End Date",
//     accessor: "enddate",
//     isInfoIcon: false,
//     isShortIcon: true,
//     className: "dg_end_date",
//     Cell: cellProps => {
//       return (
//         <div>
//           {cellProps?.row?.original?.enddate != null
//             ? moment(cellProps?.row?.original?.enddate)?.format("DD-MM-YYYY")
//             : "-"}
//         </div>
//       )
//     },
//   },
//   {
//     Header: "Spent Hrs",
//     accessor: "spent_hours",
//     isInfoIcon: false,
//     isShortIcon: true,
//     className: "dg_last_update",
//     Cell: cellProps => {
//       return (
//         <div className="">{cellProps?.row?.original?.spent_hours || "-"}</div>
//       )
//     },
//   },
//   {
//     Header: "Action",
//     accessor: "action",
//     className: "activity-action",
//     Cell: cellProps => {
//       return (
//         <>
//           {cellProps?.row?.original?.type == 1 ? (
//             <div className="d-flex justify-content-center">
//               <a
//                 className="btn btn-sm btn-outline-secondary me-1" 
//                 title="Edit Activity"
//                     onClick={() =>
//                       handleEditTask(cellProps?.row?.original, "edit")
//                     }
//               >
//                 <i className="fas fa-pen "></i>
//               </a>

//               <a
//                 title="Add Hours"
//                 className="btn btn-sm btn-outline-secondary me-1"
//                 onClick={() => {
//                   console.log(
//                     "CellProps.row.original: ",
//                     cellProps.row.original
//                   )
//                   handleAddHour(
//                     cellProps.row.original.id,
//                     cellProps?.row?.original?.related_to,
//                     cellProps?.row?.original?.related_id,
//                     cellProps.row.original
//                   )
//                 }}
//               >
//                 <i className="bi bi-alarm-fill"></i>
//               </a>
//               <UncontrolledDropdown
//                 className="dropdown"
//                 style={{ width: "29px" }}
//               >
//                 <DropdownToggle
//                   className="btn btn-sm btn-outline-secondary w-100"
//                   color="white"
//                 >
//                   <i className="mdi mdi-dots-horizontal"></i>
//                 </DropdownToggle>
//                 <DropdownMenu className="dropdown-menu-end"> 
//                   <a
//                     className="dropdown-item"
//                     title="View Activity"
//                     onClick={() => handleEditTask(cellProps?.row?.original, "view")}
//                   >
//                     <i className="fas fa-eye pr-10"></i> View Activity
//                   </a>
//                   <a
//                     title="Delete Activity"
//                     className="dropdown-item"
//                     onClick={() => onDelete(cellProps?.row?.original?.id)}
//                   >
//                     <i className="fas fa-trash-alt text-danger pr-10"></i>{" "}
//                     Delete Activity
//                   </a>
//                 </DropdownMenu>
//               </UncontrolledDropdown>
//             </div>
//           ) : cellProps?.row?.original?.type == 2 ? (
//             <div className="d-flex">
//               {/* <a
//                 title="Lead Info"
//                 className="btn btn-sm btn-outline-secondary me-1"
//                 onClick={() => {
//                   handleViewLead(true)
//                 }}
//               >
//                 <i className="fas fa-info"></i>
//               </a> */}
//               <Link
//                 title="view lead"
//                 className="btn btn-sm btn-outline-secondary me-1"
//                 to={`${configure.appUrl}sales/edit-lead/${cellProps.row.original?.related_id}`}
//                 target="_blank"
//               >
//                 <i className="fas fa-arrow-right"></i>
//               </Link>
//               <a
//                 title="Add Task"
//                 className="btn btn-sm btn-outline-secondary me-1 "
//                 onClick={() => onAddTask(
//                     cellProps.row.original?.related_id,
//                     cellProps.row.original.id,
//                   )}
//               >
//                 <i className="fas fa-clipboard-list"></i>
//               </a>
//             </div>
//           ) : (
//             <div className="d-flex">
//               <Link
//                 to={`${configure.appUrl}sales/view-contract/${cellProps?.row?.original?.id}`}
//                 target="_blank"
//                 title="Lead Info"
//                 className="btn btn-sm btn-outline-secondary me-1"
//               >
//                 <i className="fas fa-eye"></i>
//               </Link>
//               <a
//                 className="btn btn-sm btn-outline-primary me-1"
//                 title="Approve"
//                 onClick={() => handleApprove(cellProps?.row?.original?.id)}
//               >
//                 <i className="bi bi-check-lg icon-center"></i>
//               </a>
//             </div>
//           )}
//         </>
//       )
//     },
//   },
// ]
export const generalDashboardColumns = (
  handleEditTask,
  onDelete,
  handleChangeStatus,
  onManagePlan,
  handleAddHour,
  followChangeStatus,
  onAddTask,
  handleApprove
) => [
    {
      Header: "Id",
      accessor: "id",
      isInfoIcon: false,
      isShortIcon: true,
      className: "dg_id",
      Cell: cellProps => {
        const [status, setStatus] = useState(cellProps?.row?.original?.plan_day)
        useEffect(() => {
          setStatus(cellProps?.row?.original?.plan_day)
        }, [cellProps?.row?.original?.plan_day])
        return (
          <div className="d-flex justify-content-center align-items-center gap-1">
            <span>
              {cellProps?.row?.original.type != 3 ? (
                <a
                  className="color-grey me-1"
                  title="Plan My Day"
                  onClick={() => {
                    onManagePlan(
                      cellProps.row.original?.id,
                      status == 0 ? 1 : 0,
                      cellProps?.row?.original?.type
                    )
                    setStatus(status == 0 ? 1 : 0)
                  }}
                >
                  <i
                    className={`${status == 1
                      ? "bi bi-brightness-high-fill color-orange"
                      : "bi bi-brightness-high "
                      } fs-4`}
                  ></i>
                </a>
              ) : null}
            </span>
            <span>{cellProps.row.original.id}</span>
          </div>
        )
      },
    },
    {
      Header: "Status",
      accessor: "status",
      isInfoIcon: false,
      isShortIcon: true,
      className: "dg-com-status text-center",
      Cell: cellProps => {
        const [isChecked, setIsChecked] = useState(
          cellProps.row.original.checked || false
        )
        const handleCheckboxChange = async (e, id) => {
          const checked = e.target.checked
          setIsChecked(checked)
          const userConfirmed = await Swal.fire({
            title: "Are you sure?",
            text: `${cellProps.row.original.added_by != localStorage.getItem("auth_id")
              ? "You want to Mark as complete ?"
              : "You have Reviewed this Activity before completing?"
              }`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, change it!",
            cancelButtonText: "No, cancel",
          })

          if (userConfirmed.isConfirmed) {
            handleChangeStatus(
              e,
              cellProps.row.original.id,
              cellProps?.row?.original?.related_to,
              cellProps?.row?.original?.related_id,
              cellProps.row.original.added_by != localStorage.getItem("auth_id")
                ? "complete"
                : "",
              cellProps.row.original.added_by == localStorage.getItem("auth_id"),
              cellProps.row.original
            )
            setIsChecked(false)
          } else {
            setIsChecked(false)
          }
        }

        const assignee = cellProps?.row?.original?.assigned?.split(",")

        return (
          <div className="d-flex align-items-center gap-3 justify-content-center">
            <span>
              {/* {moment(cellProps?.row?.original?.created_at).format("DD-MM-YYYY")} */}
              {moment(
                cellProps?.row?.original?.type === 1
                  ? cellProps?.row?.original?.startdate
                  : cellProps?.row?.original?.created_at,
              ).format("DD-MM-YYYY")}
            </span>
            {cellProps.row.original.type === 1 ? (
              <>
                {cellProps?.row?.original?.img ? (
                  <img
                    src={`${configure.imgUrl}${cellProps?.row?.original?.img}`}
                    alt=""
                    className="img-fluid assignee-img"
                    title={cellProps?.row?.original?.added_by_name}
                  />
                ) : (
                  <div
                    className="defualt-img "
                    title={cellProps?.row?.original?.added_by_name}
                  >
                    {getInitials(cellProps?.row?.original?.added_by_name || "Z")}
                  </div>
                )}
              </>
            ) : (
              <>
                {cellProps?.row?.original?.avatar ? (
                  <img
                    src={`${cellProps?.row?.original?.avatar
                      ? `${configure?.imgUrl}${cellProps?.row?.original?.avatar}`
                      : sideImg
                      }`}
                    alt=""
                    className="img-fluid assignee-img"
                    title={cellProps?.row?.original?.added_by_name}
                  />
                ) : (
                  <div
                    className="defualt-img "
                    title={cellProps?.row?.original?.added_by_name}
                  >
                    {getInitials(cellProps?.row?.original?.added_by_name || "Z")}
                  </div>
                )}
              </>
            )}

            <div className="text-end" id="customCheckbox">
              {cellProps.row.original.type === 1 ? (
                <>
                  {cellProps.row.original?.status != "mark-completed" ||
                    cellProps.row.original.added_by ==
                    localStorage.getItem("auth_id") ? (
                    <>
                      {assignee?.length > 1 &&
                        cellProps.row.original.added_by ==
                        localStorage.getItem("auth_id") ? (
                        <>
                          {cellProps.row.original?.status != "mark-completed" &&
                            cellProps.row.original?.status != "complete" ? (
                            <input
                              type="checkbox"
                              className="form-check-input custom-checkbox  mt-2im general-status"
                              id={`customCheck-${cellProps.row.id}`}
                              value="complete"
                              checked={isChecked}
                              onChange={e =>
                                handleCheckboxChange(
                                  e,
                                  cellProps.row.original.id,
                                  cellProps.row.original
                                )
                              }
                            />
                          ) : null}
                        </>
                      ) : (
                        <input
                          type="checkbox"
                          className="form-check-input custom-checkbox  mt-2im general-status"
                          id={`customCheck-${cellProps.row.id}`}
                          value="complete"
                          checked={isChecked}
                          onChange={e =>
                            handleCheckboxChange(e, cellProps.row.original.id)
                          }
                        />
                      )}
                    </>
                  ) : null}
                </>
              ) : cellProps.row.original.type === 2 ? (
                <>
                  <div className="text-center">
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() =>
                        followChangeStatus({
                          user_id: localStorage.getItem("auth_id"),
                          followup_id: cellProps.row.original.id,
                          lead_id: cellProps.row.original.related_id,
                        })
                      }
                    >
                      <i className="fas fa-check"></i>
                    </button>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        )
      },
    },
    {
      Header: "Related",
      accessor: "related",
      isInfoIcon: false,
      isShortIcon: false,
      className: "dg-related",
      Cell: cellProps => {
        let priorty
        if (cellProps.row.original?.priorty == "high") {
          priorty = <i title="High priority" className="bx bxs-hot icon-hot"></i>
        } else if (cellProps.row.original?.priorty == "medium") {
          priorty = (
            <i title="Medium priority" className="bx bxs-flame icon-flame"></i>
          )
        } else if (cellProps.row.original?.priorty == "low") {
          priorty = <i title="Low priority" className="bx bxs-sun icon-sun"></i>
        }
        return (
          <>
            {priorty}
            {cellProps.row.original?.type == 3 ? (
              <a className={`fs-3 ms-2`}>
                <i className="mdi mdi-file-document-edit"></i>
              </a>
            ) : (
              <a
                className={`fs-3 ms-2 ${RelatedToOption?.find(
                  obj => obj?.value == cellProps.row.original.related
                )?.color
                  }`}
                title={`${RelatedToOption?.find(
                  obj => obj?.value == cellProps.row.original.related
                )?.label
                  }`}
              >
                <i
                  className={`${RelatedToOption?.find(
                    obj => obj?.value == cellProps.row.original.related
                  )?.icon
                    }`}
                ></i>
              </a>
            )}
          </>
        )
      },
    },
    {
      Header: "Task Name",
      accessor: "title",
      isInfoIcon: false,
      isShortIcon: true,
      className: "dg_task_name",
      Cell: cellProps => {
        const subTasks = cellProps.row?.original?.subtasks
        const isAssignee = subTasks?.filter(
          obj => obj?.assign == localStorage.getItem("auth_id")
        )
        const shownSubTask =
          isAssignee != undefined && isAssignee?.length != 0 ? isAssignee : null
        return (
          <div>
            {cellProps.row.original.type == 3 ? (
              <div>
                {cellProps?.row?.original?.cust_company_name ||
                  cellProps?.row?.original?.lead_company_name ||
                  cellProps?.row?.original?.intro_company_name}
              </div>
            ) : (
              <div>
                <strong>
                  {" "}
                  {shownSubTask?.length != 0 && shownSubTask != null ? (
                    <i className="bx bx-subdirectory-right fs-5"></i>
                  ) : null}
                  {` ${cellProps?.row?.original?.related_name ||
                    cellProps?.row?.original?.related_to != null
                    ? `${cellProps?.row?.original?.related_name ||
                    cellProps?.row?.original?.related_to
                    } - `
                    : ""
                    }`}
                </strong>{" "}
                {cellProps?.row?.original?.title}
                <div className="ms-4">
                  {shownSubTask?.length != 0 && shownSubTask != null ? (
                    <>
                      {shownSubTask?.map((obj, i) => {
                        return (
                          <p
                            className={`mb-0 subtask-title ${obj?.status == 1
                              ? "text-decoration-line-through text-success"
                              : ""
                              }`}
                            key={i}
                          >
                            - {obj?.title} :{" "}
                            <span className="fw-bold">{obj?.enddate}</span>
                          </p>
                        )
                      })}
                    </>
                  ) : null}
                </div>
              </div>
            )}
          </div>
        )
      },
    },
    {
      Header: "End Date",
      accessor: "enddate",
      isInfoIcon: false,
      isShortIcon: true,
      className: "dg_end_date",
      Cell: cellProps => {
        return (
          <div>
            {cellProps?.row?.original?.enddate != null
              ? moment(cellProps?.row?.original?.enddate)?.format("DD-MM-YYYY")
              : "-"}
          </div>
        )
      },
    },
    {
      Header: "Spent Hrs",
      accessor: "spent_hours",
      isInfoIcon: false,
      isShortIcon: true,
      className: "dg_last_update",
      Cell: cellProps => {
        return (
          <div className="">{cellProps?.row?.original?.spent_hours || "-"}</div>
        )
      },
    },
    {
      Header: "Action",
      accessor: "action",
      className: "activity-action",
      Cell: cellProps => {
        return (
          <>
            {cellProps?.row?.original?.type == 1 ? (
              <div className="d-flex justify-content-center">
                <a
                  className="btn btn-sm btn-outline-secondary me-1"
                  title="Edit Activity"
                  onClick={() =>
                    handleEditTask(cellProps?.row?.original, "edit")
                  }
                >
                  <i className="fas fa-pen "></i>
                </a>

                <a
                  title="Add Hours"
                  className="btn btn-sm btn-outline-secondary me-1"
                  onClick={() => {
                    console.log(
                      "CellProps.row.original: ",
                      cellProps.row.original
                    )
                    handleAddHour(
                      cellProps.row.original.id,
                      cellProps?.row?.original?.related_to,
                      cellProps?.row?.original?.related_id,
                      cellProps.row.original
                    )
                  }}
                >
                  <i className="bi bi-alarm-fill"></i>
                </a>
                <UncontrolledDropdown
                  className="dropdown"
                  style={{ width: "29px" }}
                >
                  <DropdownToggle
                    className="btn btn-sm btn-outline-secondary w-100"
                    color="white"
                  >
                    <i className="mdi mdi-dots-horizontal"></i>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-end">
                    <a
                      className="dropdown-item"
                      title="View Activity"
                      onClick={() => handleEditTask(cellProps?.row?.original, "view")}
                    >
                      <i className="fas fa-eye pr-10"></i> View Activity
                    </a>
                    <a
                      title="Delete Activity"
                      className="dropdown-item"
                      onClick={() => onDelete(cellProps?.row?.original?.id)}
                    >
                      <i className="fas fa-trash-alt text-danger pr-10"></i>{" "}
                      Delete Activity
                    </a>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            ) : cellProps?.row?.original?.type == 2 ? (
              <div className="d-flex">
                <Link
                  title="view lead"
                  className="btn btn-sm btn-outline-secondary me-1"
                  to={`${configure.appUrl}sales/edit-lead/${cellProps.row.original?.related_id}`}
                  target="_blank"
                >
                  <i className="fas fa-arrow-right"></i>
                </Link>
                <a
                  title="Add Task"
                  className="btn btn-sm btn-outline-secondary me-1 "
                  onClick={() =>
                    onAddTask(
                      cellProps.row.original?.related_id,
                      cellProps.row.original.id,
                    )}
                >
                  <i className="fas fa-clipboard-list"></i>
                </a>
              </div>
            ) : (
              <div className="d-flex">
                <Link
                  to={`${configure.appUrl}sales/view-contract/${cellProps?.row?.original?.id}`}
                  target="_blank"
                  title="Lead Info"
                  className="btn btn-sm btn-outline-secondary me-1"
                >
                  <i className="fas fa-eye"></i>
                </Link>
                <a
                  className="btn btn-sm btn-outline-primary me-1"
                  title="Approve"
                  onClick={() => handleApprove(cellProps?.row?.original?.id)}
                >
                  <i className="bi bi-check-lg icon-center"></i>
                </a>
              </div>
            )}
          </>
        )
      },
    },
  ]

export const contractDashboardColumns = (onApproveStatus, onViewContract) => [
  {
    Header: "ID",
    accessor: "id",
    isInfoIcon: false,
    className: "text-center col-md-1",
  },
  {
    Header: "Assigned",
    accessor: "assign",
    className: "col-1",
    Cell: cellProps => {
      return (
        <div className="text-center d-flex align-items-center">
          <img
            src={`${configure.imgUrl}${cellProps.row.original.img}`}
            alt=""
            className="assigned-img mx-1"
            width="20"
            height="20"
          />
          {cellProps.row.original.location != null ? (
            <img
              src={cellProps.row.original.location == 1 ? indiaFlag : ukFlag}
              className=" mx-1 location-img"
              alt="flag"
              width="20"
              height="15"
            />
          ) : null}
        </div>
      )
    },
    isInfoIcon: true,
  },
  {
    Header: "Company",
    accessor: "company_name",
    isInfoIcon: true,
    className: " col-md-5",
    Cell: cellProps => {
      return (
        <div>
          {cellProps?.row?.original?.cust_company_name ||
            cellProps?.row?.original?.lead_company_name ||
            cellProps?.row?.original?.intro_company_name}
        </div>
      )
    },
  },
  {
    Header: "Service",
    accessor: "service",
    isInfoIcon: true,
    className: "text-center col-md-2",
  },
  {
    Header: "Amount",
    accessor: "value",
    isInfoIcon: true,
    className: "text-center col-md-1",
    Cell: cellProps => {
      return (
        <div>
          {cellProps.row.original.value != null ? (
            <>
              {cellProps.row.original.currency_symbol || "-"}{" "}
              {cellProps.row.original.value}
            </>
          ) : (
            "-"
          )}
        </div>
      )
    },
  },
  {
    Header: "Duration",
    accessor: "duration",
    isInfoIcon: true,
    className: "col-md-1",
    Cell: cellProps => {
      const startDate = new Date(cellProps.row.original.startdate)
      const endDate = new Date(cellProps.row.original.enddate)
      const timeDifference = endDate - startDate
      const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24))
      return <div>{daysDifference} days</div>
    },
  },
  {
    Header: "Sent Date",
    accessor: "startdate",
    isInfoIcon: true,
    className: "col-md-1",
    Cell: cellProps => {
      return (
        <div>
          {cellProps.row.original?.startdate != null
            ? moment(cellProps.row.original?.startdate).format("DD-MM-YYYY")
            : "-"}
        </div>
      )
    },
  },
  {
    Header: "End Date",
    accessor: "enddate",
    isInfoIcon: true,
    className: "col-md-1",
    Cell: cellProps => {
      return (
        <div>
          {cellProps.row.original?.enddate != null
            ? moment(cellProps.row.original?.enddate).format("DD-MM-YYYY")
            : "-"}
        </div>
      )
    },
  },
  {
    Header: "Action",
    accessor: "action",
    className: "col-md-1",
    Cell: cellProps => {
      return (
        <div className="d-flex">
          <a
            title="View"
            className="btn btn-sm btn-outline-secondary me-1"
            onClick={() => onViewContract(cellProps?.row?.original?.id)}
          >
            <i className="fas fa-eye "></i>
          </a>
          <a
            className="btn btn-sm btn-outline-primary me-1"
            title="Approve"
            onClick={() => onApproveStatus(cellProps?.row?.original?.id, 1, 5)}
          >
            <i className="bi bi-check-lg icon-center"></i>
          </a>
          <a
            className="btn btn-sm btn-outline-danger me-1"
            title="Disapprove"
            onClick={() =>
              onApproveStatus(cellProps?.row?.original?.id, 2, 5, "2")
            }
          >
            <i className="bi bi-x-lg icon-center"></i>
          </a>
        </div>
      )
    },
  },
]

export const invoiceDashboardColumns = (onApproveZtpl, onViewinvoice) => [
  {
    Header: "Id",
    accessor: "id",
    isInfoIcon: false,
    className: "text-center id-col tab-1",
  },
  {
    Header: "Date",
    accessor: "invoice_date",
    isInfoIcon: false,
    className: "text-center date-col tab-2",
    Cell: (cellProps) => {
      return (
        <div>
          {moment(cellProps?.row?.original?.invoice_date).format("DD-MM-YYYY")}
        </div>
      );
    },
  },
  {
    Header: "Invoice No.",
    accessor: "invoice_number",
    grow: false,
    className: "prf_invoice_box text-center tab-3",
    isInfoIcon: true,
  },

  {
    Header: "Customer",
    accessor: "company",
    isInfoIcon: true,
    className: "customer-col tab-4",
  },
  {
    Header: "Amount",
    accessor: "total",
    isInfoIcon: true,
    className: "text-center amount-col tab-6",
    Cell: (cellProps) => {
      return (
        <div>
          {(Math.floor(parseFloat(cellProps?.row?.original?.total) * 100) / 100).toFixed(2)}

        </div>
      );
    },
  },
  {
    Header: "Due Date",
    accessor: "due_date",
    isInfoIcon: false,
    className: "text-center due_date-col tab-5",
  },
  {
    Header: "Action",
    accessor: "action",
    className: "text-center col-md-1",
    Cell: (cellProps) => {
      return (
        <div className="d-flex">
          <a
            title="View"
            className="btn btn-sm btn-outline-secondary me-1"
            onClick={() => onViewinvoice(cellProps?.row?.original?.id)}
          >
            <i className="fas fa-eye "></i>
          </a>
          <a
            className="btn btn-sm btn-outline-primary me-1"
            title="Approve"
            onClick={() => onApproveZtpl(cellProps?.row?.original?.id, 1, 3)}
          >
            <i className="bi bi-check-lg icon-center"></i>
          </a>
        </div>
      );
    },
  },
];
export const ProposalDashboardColumns = onApproveStatus => [
  {
    Header: "ID",
    accessor: "id",
    isInfoIcon: false,
    className: "text-center col-md-1",
  },
  {
    Header: "Assigned",
    accessor: "assign",
    className: "col-md-1",
    Cell: cellProps => {
      return (
        <div className="text-center d-flex align-items-center">
          <img
            src={`${configure.imgUrl}${cellProps.row.original.img}`}
            alt=""
            className="assigned-img mx-1"
            height="20"
            width="20"
          />
          {cellProps.row.original.location != null ? (
            <img
              src={cellProps.row.original.location == 1 ? indiaFlag : ukFlag}
              className=" mx-1 location-img"
              alt="flag"
              width="20"
              height="15"
            />
          ) : null}
        </div>
      )
    },
    isInfoIcon: true,
  },
  {
    Header: "Client Name",
    accessor: "companyname",
    isInfoIcon: true,
  },
  {
    Header: "Proposal Title",
    accessor: "proposaltitile",
    isInfoIcon: true,
    Cell: cellProps => {
      return (
        <span className="text-dark">
          {cellProps.row.original.proposaltitile}
        </span>
      )
    },
  },
  // {
  //     Header: "Service",
  //     accessor: "service",
  //     isInfoIcon: true,
  //     className: "col-md-1"
  // },
  {
    Header: "Price",
    accessor: "price",
    isInfoIcon: true,
    className: "",
    Cell: cellProps => {
      const array = JSON.parse(cellProps.row.original?.costbreakdown) || []
      const totalSum = array?.reduce((accumulator, item) => {
        const totalValue = parseFloat(item.totalcost) // Convert "total" to a number
        if (!isNaN(totalValue)) {
          return accumulator + totalValue
        }
        return accumulator // Skip items with invalid "total" values
      }, 0)
      return (
        <div>
          {cellProps.row.original.currency}{" "}
          {parseFloat(totalSum).toFixed(2) || 0}
        </div>
      )
    },
  },
  {
    Header: "Created At",
    accessor: "created_at",
    isInfoIcon: true,
    className: "col-md-1",
    Cell: cellProps => {
      return (
        <div>
          {moment(cellProps.row.original.created_at).format("DD-MM-YYYY") ||
            "-"}
        </div>
      )
    },
  },
  {
    Header: "Open Till",
    accessor: "opentill",
    isInfoIcon: true,
    className: "col-md-1",
    Cell: cellProps => {
      return (
        <span>
          {moment(cellProps.row.original.opentill).format("DD-MM-YYYY")}
        </span>
      )
    },
  },
  {
    Header: "Action",
    accessor: "action",
    className: "col-md-1",
    Cell: cellProps => {
      return (
        <div className="d-flex">
          {/* <a
                        title="View"
                        className="btn btn-sm btn-outline-secondary me-1"
                    >
                        <i className="fas fa-eye "></i>
                    </a> */}
          <a
            className="btn btn-sm btn-outline-primary me-1"
            title="Approve"
            onClick={() => onApproveStatus(cellProps?.row?.original?.id, 1, 6)}
          >
            <i className="bi bi-check-lg icon-center"></i>
          </a>
        </div>
      )
    },
  },
]

export const leavesDashboardColumns = onLeaveDetail => [
  {
    Header: "ID",
    accessor: "id",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center lemp-id",
  },
  {
    Header: "Employee Name",
    accessor: "name",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-md-3",
  },
  {
    Header: "Reason",
    accessor: "leave_reason",
    isInfoIcon: false,
    isShortIcon: true,
    className: "lreason_box text-start",
  },
  {
    Header: "Applied On",
    accessor: "created_at",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center lapplied_on_box",
    Cell: cellProps => {
      return (
        <div>
          {moment(cellProps?.row?.original.created_at).format("DD-MM-YYYY")}
        </div>
      )
    },
  },
  {
    Header: "End Date",
    accessor: "end_date",
    isInfoIcon: false,
    isShortIcon: true,
    className: "lemployee_code-box text-center",
  },
  {
    Header: "Total Days",
    accessor: "leave_days",
    isInfoIcon: false,
    isShortIcon: true,
    className: "lemployee_code-box text-center",
  },

  {
    Header: "Action",
    accessor: "action",
    className: "col-1",
    Cell: cellProps => {
      return (
        <div className="d-flex">
          <a
            title="View"
            className="btn btn-sm btn-outline-secondary me-1"
            onClick={() =>
              onLeaveDetail(
                cellProps?.row?.original?.id,
                cellProps?.row?.original?.employee
              )
            }
          >
            <i className="fas fa-eye "></i>
          </a>
        </div>
      )
    },
  },
]

export const projectApprovalColumns = () => [
  {
    Header: "ID",
    accessor: "id",
    isInfoIcon: false,
    className: "text-center col-md-1",
  },
  {
    Header: "Type",
    accessor: "assign",
    className: "col-md-2",
    isInfoIcon: true,
    Cell: cellProps => {
      // console.log(cellProps?.row?.original?.type)
      return (
        <div>
          Digital Marketing -{" "}
          {
            DigitalServiceOptionsDrop?.find(
              obj => obj?.value == cellProps?.row?.original?.ptype
            )?.label
          }
        </div>
      )
    },
  },
  {
    Header: "Project Name",
    accessor: "project_name",
    isInfoIcon: true,
  },
  {
    Header: "Start Date",
    accessor: "start_date",
    className: "col-md-1",
    isInfoIcon: true,
  },
  {
    Header: "End Date",
    accessor: "end_date",
    className: "col-md-1",
    isInfoIcon: true,
  },
  {
    Header: "Action",
    accessor: "action",
    className: "col-md-1",
    Cell: cellProps => {
      const data = cellProps?.row?.original
      console.log(data)
      return (
        <div className="d-flex justify-content-center">
          <Link
            to={`${configure.appUrl}initial-project-plan/${data?.project_id}/${data?.ptype}#rollout`}
            title="View"
            className="btn btn-sm btn-outline-secondary me-1"
          >
            <i className="fas fa-eye "></i>
          </Link>
        </div>
      )
    },
  },
]

export const todayPlanClolumns = (
  onEditTask,
  onDeleteTask,
  handleStatus,
  FollowupStatus,
  onAddHours,
  onFollowTask
) => [
    {
      Header: "Status",
      accessor: "status",
      isInfoIcon: false,
      isShortIcon: true,
      className: "pl_status-id text-center",
      Cell: cellProps => {
        const [isChecked, setIsChecked] = useState(
          cellProps.row.original.checked || false
        )
        const handleCheckboxChange = async (e, id) => {
          const checked = e.target.checked
          setIsChecked(checked)
          const userConfirmed = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to change the status?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, change it!",
            cancelButtonText: "No, cancel",
          })

          if (userConfirmed.isConfirmed) {
            handleStatus(
              e,
              cellProps.row.original.id,
              cellProps?.row?.original?.related_to,
              cellProps?.row?.original?.related_id,
              cellProps.row.original.added_by != localStorage.getItem("auth_id")
                ? "complete"
                : "",
              cellProps.row.original.added_by == localStorage.getItem("auth_id"),
              cellProps.row.original
            )
            setIsChecked(false)
          } else {
            setIsChecked(false)
          }
        }

        return (
          <div className="d-flex align-items-center gap-3 justify-content-start">
            <img
              src={`${cellProps?.row?.original?.added_user
                  ? `${configure?.imgUrl}${cellProps?.row?.original?.added_user}`
                  : sideImg
                }`}
              alt=""
              className="img-fluid assignee-img"
              title={cellProps?.row?.original?.added_by_name}
            />
            <div className="text-end" id="customCheckbox">
              {cellProps.row.original.type != "followup" ? (
                <>
                  {cellProps.row.original?.status != "complete" ? (
                    <input
                      type="checkbox"
                      className="form-check-input custom-checkbox mt-2im general-status"
                      id={`customCheck-${cellProps.row.id}`}
                      value="complete"
                      disabled={
                        cellProps.row.original.added_by !=
                        localStorage.getItem("auth_id")
                      }
                      checked={isChecked}
                      onChange={e =>
                        handleCheckboxChange(e, cellProps.row.original.id)
                      }
                    />
                  ) : null}
                </>
              ) : (
                <div className="text-center">
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() =>
                      followChangeStatus({
                        user_id: localStorage.getItem("auth_id"),
                        followup_id: cellProps.row.original.id,
                      })
                    }
                  >
                    <i className="fas fa-check"></i>
                  </button>
                </div>
              )}
            </div>
          </div>
        )
      },
    },
    {
      Header: "Id",
      accessor: "id",
      isInfoIcon: false,
      isShortIcon: true,
      className: "pl_id",
      Cell: cellProps => {
        return (
          <div className="d-flex gap-2 justify-content-center align-items-center">
            <a
              className={`fs-5 line-height-0 ${RelatedToOption?.find(
                obj => obj?.value == cellProps.row.original.related
              )?.color
                }`}
              title={`${RelatedToOption?.find(
                obj => obj?.value == cellProps.row.original.related
              )?.label
                }`}
            >
              <i
                className={`${RelatedToOption?.find(
                  obj => obj?.value == cellProps.row.original.related
                )?.icon
                  }`}
              ></i>
            </a>
            {cellProps.row.original.id}
          </div>
        )
      },
    },
    {
      Header: "Task Name",
      accessor: "title",
      isInfoIcon: false,
      isShortIcon: true,
      className: "pl_task_name",
      Cell: cellProps => {
        let priorty
        if (cellProps.row.original?.priorty == "high") {
          priorty = <i title="High priority" className="bx bxs-hot icon-hot"></i>
        } else if (cellProps.row.original?.priorty == "medium") {
          priorty = (
            <i title="Medium priority" className="bx bxs-flame icon-flame"></i>
          )
        } else if (cellProps.row.original?.priorty == "low") {
          priorty = <i title="Low priority" className="bx bxs-sun icon-sun"></i>
        }

        const subTasks = cellProps.row?.original?.subtasks
        const isAssignee = subTasks?.filter(
          obj => obj?.assign == localStorage.getItem("auth_id")
        )
        const shownSubTask =
          isAssignee != undefined && isAssignee?.length != 0 ? isAssignee : null
        return (
          <div className="text-capitalize">
            {priorty}
            <strong>
              {shownSubTask?.length != 0 && shownSubTask != null ? (
                <i className="bx bx-subdirectory-right fs-5"></i>
              ) : null}
              {` ${cellProps?.row?.original?.related_name ||
                  cellProps?.row?.original?.related_to != null
                  ? `${cellProps?.row?.original?.related_name ||
                  cellProps?.row?.original?.related_to
                  } - `
                  : ""
                }`}{" "}
            </strong>
            {cellProps.row?.original?.title || "-"}
            <div className="ms-5">
              {shownSubTask?.length != 0 && shownSubTask != null ? (
                <>
                  {shownSubTask?.map((obj, i) => {
                    return (
                      <p
                        className={`mb-0 subtask-title ${obj?.status == 1
                            ? "text-decoration-line-through text-success"
                            : ""
                          }`}
                        key={i}
                      >
                        - {obj?.title} :{" "}
                        <span className="fw-bold">{obj?.enddate}</span>
                      </p>
                    )
                  })}
                </>
              ) : null}
            </div>
          </div>
        )
      },
    },
    {
      Header: "End Date",
      accessor: "enddate",
      isInfoIcon: false,
      isShortIcon: true,
      className: "pl_end_date",
      Cell: cellProps => {
        return (
          <div>
            {moment(cellProps?.row?.original?.enddate)?.format("DD-MM-YYYY")}
          </div>
        )
      },
    },

    {
      Header: "Est. Time",
      accessor: "estimate_time",
      isInfoIcon: false,
      isShortIcon: true,
      className: "pl-esttime",
      Cell: cellProps => {
        return (
          <div className="text-capitalize">
            {cellProps.row?.original?.estimate_time || "-"}
          </div>
        )
      },
    },
    {
      Header: "Today's Time",
      accessor: "spent_hours",
      isInfoIcon: false,
      isShortIcon: true,
      className: "pl-esttime",
      Cell: cellProps => {
        return (
          <div className="text-capitalize">
            {cellProps.row?.original?.spent_hours || "-"}
          </div>
        )
      },
    },
    {
      Header: "Action",
      accessor: "action",
      isInfoIcon: false,
      isShortIcon: true,
      className: "pl_priority",
      Cell: cellProps => {
        return (
          <>
            {cellProps?.row?.original?.type != "followup" ? (
              <div className="d-flex justify-content-center">
                <a
                  className="btn btn-sm btn-outline-secondary me-1"
                  title="View Activity"
                  onClick={() => onEditTask(cellProps?.row.original, "view")}
                >
                  <i className="fas fa-eye "></i>
                </a>
                <a
                  title="Add Hours"
                  className="btn btn-sm btn-outline-secondary me-1"
                  onClick={() =>
                    onAddHours(
                      cellProps.row.original.id,
                      cellProps?.row?.original?.related_to,
                      cellProps?.row?.original?.related_id
                    )
                  }
                >
                  <i className="bi bi-alarm-fill"></i>
                </a>
                <UncontrolledDropdown
                  className="dropdown"
                  style={{ width: "29px" }}
                >
                  <DropdownToggle
                    className="btn btn-sm btn-outline-secondary w-100"
                    color="white"
                  >
                    <i className="mdi mdi-dots-horizontal"></i>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-end">
                    <a
                      className="dropdown-item"
                      title="Edit Activity"
                      onClick={() => onEditTask(cellProps?.row.original, "edit")}
                    >
                      <i className="fas fa-pen pr-10"></i>
                      Edit Activity
                    </a>
                    <a
                      title="Delete Activity"
                      className="dropdown-item"
                      onClick={() => onDeleteTask(cellProps?.row.original.id)}
                    >
                      <i className="fas fa-trash-alt text-danger pr-10"></i>{" "}
                      Delete Activity
                    </a>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            ) : (
              <div className="d-flex gap-1">
                <Link
                  title="view lead"
                  className="btn btn-sm btn-outline-secondary me-1"
                  to={`${configure.appUrl}sales/edit-lead/${cellProps.row.original?.related_id}`}
                >
                  <i className="fas fa-arrow-right"></i>
                </Link>
                <a
                  title="Add Task"
                  className="btn btn-sm btn-outline-secondary me-1 "
                  onClick={() => onFollowTask(cellProps.row.original?.related_id)}
                >
                  <i className="fas fa-clipboard-list"></i>
                </a>
              </div>
            )}
          </>
        )
      },
    },
  ]

export const YesterDayPlanClolumns = onAddHours => [
  {
    Header: "Id",
    accessor: "id",
    isInfoIcon: false,
    isShortIcon: true,
    className: "pl_id",
    Cell: cellProps => {
      return (
        <div className="d-flex gap-2 justify-content-center align-items-center">
          <a
            className={`fs-5 line-height-0 ${RelatedToOption?.find(
              obj => obj?.value == cellProps.row.original.related
            )?.color
              }`}
            title={`${RelatedToOption?.find(
              obj => obj?.value == cellProps.row.original.related
            )?.label
              }`}
          >
            <i
              className={`${RelatedToOption?.find(
                obj => obj?.value == cellProps.row.original.related
              )?.icon
                }`}
            ></i>
          </a>
          {cellProps.row.original.id}
        </div>
      )
    },
  },
  {
    Header: "Task Name",
    accessor: "title",
    isInfoIcon: false,
    isShortIcon: true,
    className: "pl_task_name",
    Cell: cellProps => {
      const subTasks = cellProps.row?.original?.subtasks
      const isAssignee = subTasks?.filter(
        obj => obj?.assign == localStorage.getItem("auth_id")
      )
      const shownSubTask =
        isAssignee != undefined && isAssignee?.length != 0 ? isAssignee : null
      return (
        <div className="text-capitalize">
          <strong>
            {shownSubTask?.length != 0 && shownSubTask != null ? (
              <i className="bx bx-subdirectory-right fs-5"></i>
            ) : null}
            {` ${cellProps?.row?.original?.related_name ||
                cellProps?.row?.original?.related_to != null
                ? `${cellProps?.row?.original?.related_name ||
                cellProps?.row?.original?.related_to
                } - `
                : ""
              }`}{" "}
          </strong>
          {cellProps.row?.original?.title || "-"}
          <div className="ms-5">
            {shownSubTask?.length != 0 && shownSubTask != null ? (
              <>
                {shownSubTask?.map((obj, i) => {
                  return (
                    <p
                      className={`mb-0 subtask-title ${obj?.status == 1
                          ? "text-decoration-line-through text-success"
                          : ""
                        }`}
                      key={i}
                    >
                      - {obj?.title} :{" "}
                      <span className="fw-bold">{obj?.enddate}</span>
                    </p>
                  )
                })}
              </>
            ) : null}
          </div>
        </div>
      )
    },
  },
  {
    Header: "End Date",
    accessor: "enddate",
    isInfoIcon: false,
    isShortIcon: true,
    className: "pl_end_date",
    Cell: cellProps => {
      return (
        <div>
          {moment(cellProps?.row?.original?.enddate)?.format("DD-MM-YYYY")}
        </div>
      )
    },
  },
  {
    Header: "Priority",
    accessor: "priorty",
    isInfoIcon: false,
    isShortIcon: true,
    className: "pl_priority",
    Cell: cellProps => {
      let priorty
      if (cellProps.row.original?.priorty == "high") {
        priorty = <i title="High priority" className="bx bxs-hot icon-hot"></i>
      } else if (cellProps.row.original?.priorty == "medium") {
        priorty = (
          <i title="Medium priority" className="bx bxs-flame icon-flame"></i>
        )
      } else if (cellProps.row.original?.priorty == "low") {
        priorty = <i title="Low priority" className="bx bxs-sun icon-sun"></i>
      }
      return <div>{priorty}</div>
    },
  },
  {
    Header: "Est. Time",
    accessor: "estimate_time",
    isInfoIcon: false,
    isShortIcon: true,
    className: "pl-esttime",
    Cell: cellProps => {
      return (
        <div className="text-capitalize">
          {cellProps.row?.original?.estimate_time || "-"}
        </div>
      )
    },
  },
  {
    Header: "Actual Time",
    accessor: "spent_hours",
    isInfoIcon: false,
    isShortIcon: true,
    className: "pl-esttime",
    Cell: cellProps => {
      return (
        <div className="text-capitalize">
          {cellProps.row?.original?.spent_hours || "-"}
        </div>
      )
    },
  },
  {
    Header: "Action",
    accessor: "action",
    isInfoIcon: false,
    isShortIcon: true,
    className: "pl-esttime",
    Cell: cellProps => {
      return (
        <a
          title="Add Hours"
          className="btn btn-sm btn-outline-secondary me-1"
          onClick={() =>
            onAddHours(
              cellProps.row.original.id,
              cellProps?.row?.original?.related_to,
              cellProps?.row?.original?.related_id
            )
          }
        >
          <i className="bi bi-alarm-fill"></i>
        </a>
      )
    },
  },
]
export const TeamsPlanClolumns = onEditTask => [
  {
    Header: "Id",
    accessor: "id",
    isInfoIcon: false,
    isShortIcon: true,
    className: "tl_id",
    Cell: cellProps => {
      return (
        <div className="d-flex gap-2 justify-content-center align-items-center">
          <img
            src={`${cellProps?.row?.original?.added_user
                ? `${configure?.imgUrl}${cellProps?.row?.original?.added_user}`
                : sideImg
              }`}
            alt=""
            className="img-fluid assignee-img"
            title={cellProps?.row?.original?.added_by_name}
          />
          <a
            className={`fs-5 line-height-0 ${RelatedToOption?.find(
              obj => obj?.value == cellProps.row.original.related
            )?.color
              }`}
            title={`${RelatedToOption?.find(
              obj => obj?.value == cellProps.row.original.related
            )?.label
              }`}
          >
            <i
              className={`${RelatedToOption?.find(
                obj => obj?.value == cellProps.row.original.related
              )?.icon
                }`}
            ></i>
          </a>
          {cellProps.row.original.id}
        </div>
      )
    },
  },
  {
    Header: "Task Name",
    accessor: "title",
    isInfoIcon: false,
    isShortIcon: true,
    className: "pl_task_name",
    Cell: cellProps => {
      return (
        <div>
          <strong>
            {` ${cellProps?.row?.original?.related_name ||
                cellProps?.row?.original?.related_to != null
                ? `${cellProps?.row?.original?.related_name ||
                cellProps?.row?.original?.related_to
                } - `
                : ""
              }`}{" "}
          </strong>{" "}
          {cellProps?.row?.original?.title}
        </div>
      )
    },
  },
  {
    Header: "End Date",
    accessor: "enddate",
    isInfoIcon: false,
    isShortIcon: true,
    className: "pl_end_date",
    Cell: cellProps => {
      return (
        <div>
          {moment(cellProps?.row?.original?.enddate)?.format("DD-MM-YYYY")}
        </div>
      )
    },
  },
  {
    Header: "Priority",
    accessor: "priorty",
    isInfoIcon: false,
    isShortIcon: true,
    className: "pl_priority",
    Cell: cellProps => {
      let priorty
      if (cellProps.row.original?.priorty == "high") {
        priorty = <i title="High priority" className="bx bxs-hot icon-hot"></i>
      } else if (cellProps.row.original?.priorty == "medium") {
        priorty = (
          <i title="Medium priority" className="bx bxs-flame icon-flame"></i>
        )
      } else if (cellProps.row.original?.priorty == "low") {
        priorty = <i title="Low priority" className="bx bxs-sun icon-sun"></i>
      }
      return <div>{priorty}</div>
    },
  },
  {
    Header: "Est. Time",
    accessor: "estimate_time",
    isInfoIcon: false,
    isShortIcon: true,
    className: "pl-esttime",
    Cell: cellProps => {
      return (
        <div className="text-capitalize">
          {cellProps.row?.original?.estimate_time || "-"}
        </div>
      )
    },
  },
  {
    Header: "Actual Time",
    accessor: "spent_hours",
    isInfoIcon: false,
    isShortIcon: true,
    className: "pl-esttime",
    Cell: cellProps => {
      return (
        <div className="text-capitalize">
          {cellProps.row?.original?.spent_hours || "-"}
        </div>
      )
    },
  },
  {
    Header: "",
    accessor: "action",
    isInfoIcon: false,
    isShortIcon: true,
    className: "pl_id",
    Cell: cellProps => {
      return (
        <div className="">
          <a
            className="btn btn-sm btn-outline-secondary me-1"
            title="View Activity"
            onClick={() => onEditTask(cellProps?.row.original, "view")}
          >
            <i className="fas fa-eye "></i>
          </a>
        </div>
      )
    },
  },
]

export const TaskTabelColumns = (
  onInfo,
  onAddHours,
  onChangeStatus,
  onStartTimer,
  isRunning,
  currentTaskId,
  setdelay_modal,
  setDevCompleteDetails
) => [
    {
      Header: "Task ID",
      accessor: "id",
      title: "ID",
      isInfoIcon: false,
      className: "project_id text-center",
    },
    {
      Header: "Task Name",
      title: "Task Name",
      accessor: "title",
      isInfoIcon: false,
      className: "col-6",
      Cell: cellProps => {
        const data = cellProps?.row?.original
        return (
          <div>
            <span title={data?.project_name}>
              {trimProjectName(data?.project_name)}
            </span>{" "}
            - {data?.title}
          </div>
        )
      },
    },
    {
      Header: "Hours",
      accessor: "estimate_dev_days",
      isInfoIcon: false,
      className: "col-1 text-center",
    },
    {
      Header: "Status",
      accessor: "status",
      isInfoIcon: false,
      className: "col-1 text-center",
      Cell: cellProps => {
        const timeToSeconds = time =>
          time
            .split(":")
            .map(Number)
            .reduceRight(
              (total, value, i, arr) =>
                total + value * 60 ** (arr.length - 1 - i),
              0
            )

        return (
          <div className="custom-select-wrapper">
            <select
              className={`form-select custom-select`}
              value={cellProps.row.original.status}
              onChange={e => {
                const estimatedSeconds = timeToSeconds(
                  `${cellProps.row.original?.estimate_dev_days}:00` || "00:00:00"
                )
                const spentSeconds = timeToSeconds(
                  cellProps.row.original?.total_time_spent || "00:00:00"
                )

                if (e.target.value == 2 && spentSeconds > estimatedSeconds) {
                  setdelay_modal(true)
                  setDevCompleteDetails(prev => ({
                    ...prev,
                    task_id: cellProps?.row?.original?.id,
                    value: e?.target?.value,
                    project_id: cellProps?.row?.original?.project_id,
                  }))
                  return
                }

                onChangeStatus(
                  cellProps?.row?.original?.id,
                  e?.target?.value,
                  cellProps?.row?.original?.project_id
                )
              }}
            >
              {developmentTaskStatus?.map((obj, i) => {
                return (
                  <option
                    value={obj?.value}
                    key={i}
                    className=""
                  // disabled={obj?.value == 0 || obj?.value != 1}
                  >
                    {obj?.label}
                  </option>
                )
              })}
            </select>
          </div>
        )
      },
    },
    {
      Header: "Time Taken",
      title: "Last Updated Days",
      accessor: "total_time_spent",
      isInfoIcon: false,
      className: "col-1 text-center",
    },
    {
      Header: "Action",
      accessor: "action",
      className: "col-1",
      Cell: cellProps => {
        const data = cellProps?.row?.original
        const isTimerRunning =
          isRunning &&
          currentTaskId == data.id &&
          localStorage.getItem("isTicketTime") != "true" &&
          localStorage.getItem("code_time") != "true"
        return (
          <div className="d-flex justify-content-center">
            <button
              className={`btn btn-sm ${isTimerRunning ? "btn-outline-danger" : "btn-outline-success"
                } me-1`}
              title="Start / Stop Timer"
              onClick={() => onStartTimer(data)}
              disabled={
                isRunning &&
                currentTaskId != data.id &&
                localStorage.getItem("timerId")
              }
            >
              <i className="fa fa-stopwatch"></i>
            </button>
            <a
              className="btn btn-sm btn-outline-secondary me-1"
              title="Info"
              onClick={() => onInfo(data)}
            >
              <i className="fa fa-info"></i>
            </a>
            <a
              className="btn btn-sm btn-outline-primary me-1"
              title="Info"
              onClick={() => onAddHours(data?.id)}
            >
              <i className="bx bxs-timer fs-5"></i>
            </a>
          </div>
        )
      },
    },
  ]

export const DigitalTaskColumns = (onGetDetails, onGetLogs) => [
  {
    Header: "Project",
    accessor: "id",
    title: "ID",
    isInfoIcon: false,
    className: "text-center task_ids",
    Cell: cellProps => {
      const row = cellProps?.row?.original
      const outputString = row?.project_name
        .split(" ")
        .map(word => word[0])
        .join("")
      return (
        <div>
          <a
            className="cursor-pointer color-grey d-flex align-items-center justify-content-center text-uppercase"
            title={cellProps?.row?.original?.project_name}
          >
            {outputString}
            <i
              className={`${DigitalServiceOptions?.find(obj => obj.id == row?.type)?.icon
                } ms-3 fs-4 ${DigitalServiceOptions?.find(obj => obj.id == row?.type)?.text
                }-color`}
            ></i>
          </a>
        </div>
      )
    },
  },
  {
    Header: "Activity Name",
    title: "Task Name",
    accessor: "name",
    isInfoIcon: false,
    className: "col-md-8",
    // className: "task_name_box",
  },

  {
    Header: "Completed Qty",
    accessor: "actual_qty",
    isInfoIcon: false,
    className: "plan-qtys text-center",
  },
  {
    Header: "Plan Qty",
    accessor: "quantity",
    isInfoIcon: false,
    className: "plan-qty text-center",
  },
  {
    Header: "Target Qty",
    accessor: "target_qty",
    isInfoIcon: false,
    className: "plan-qty targ-qty text-center",
    Cell: cellProps => {
      return (
        <div>
          {cellProps?.row?.original?.finished_qty}/
          {cellProps?.row?.original?.total_quantity}
        </div>
      )
    },
  },
  {
    Header: "Action",
    accessor: "action text-center",
    Cell: cellProps => {
      const rowIndex = cellProps.row.original
      return (
        <div className="d-flex justify-content-center ">
          <a
            className="btn btn-sm btn-outline-primary me-1"
            title="Add Activity"
            onClick={() => onGetDetails(rowIndex?.activity_id, rowIndex)}
          >
            <i className="fa fa-plus"></i>
          </a>
          <a
            className="btn btn-sm btn-outline-primary me-1"
            title="Add Activity"
            onClick={() => onGetLogs(rowIndex)}
          >
            <i className="fa fa-info"></i>
          </a>
        </div>
      )
    },
  },
]

const RESTRICTED_STAFF_IDS = [46, 50, 168]
const DESIGNATED_APPROVER_ID = 32

export const DashboardSwipesColumns = (onDisapporve, onApprove) => [
  {
    Header: "ID",
    accessor: "id",
    className: "db_swipe_id",
    isShortIcon: true,
  },  
  {
    Header: "Swipe & Issues",
    accessor: "db_swipe_name",
    className: "db_swipe_name",
    isShortIcon: true,
    Cell: cellProps => {
      return (
        <div className="d-flex justify-content-start gap-1 db_swipe_name_box align-item-center">
          {cellProps.row.original?.avatar ? (
            <img
              src={
                cellProps.row.original?.avatar != null
                  ? `${configure?.imgUrl}${cellProps?.row?.original?.avatar}`
                  : sideImg
              }
              alt="user Image"
              className="user_img_da img-fluid cursor-pointer me-2"
              title={cellProps.row.original?.name}
            />
          ) : (
            <div
              className="defualt-img me-3"
              title={cellProps?.row?.original?.name}
            >
              {getInitials(cellProps?.row?.original?.name || "Z")}
            </div>
          )}

          <div className="dahboard_swipe">
            {cellProps.row.original?.leave_type == 1 ? (
              <span className="me-3">
                {moment(cellProps.row.original?.date).format("DD-MM-YYYY")}{" "}
                {cellProps.row?.original?.time}
              </span>
            ) : cellProps.row.original?.leave_type == 2 ? (
              <span className="me-3">
                {cellProps.row.original?.amount}{" "}
                {cellProps.row.original?.type == 0 ? "Days" : "Amount"}{" "}
              </span>
            ) : null}

            {cellProps.row.original.reason}
          </div>
        </div>
      )
    },
  },
  {
    Header: "Date",
    accessor: "db_swipe_date",
    className: "db_swipe_date",
    isShortIcon: true,
    Cell: cellProps => {
      return (
        <div>
          {moment(cellProps?.row?.original?.created_at).format("DD-MM-YYYY")}
        </div>
      )
    },
  },
  {
    Header: "Action",
    accessor: "db_swipe_actions text-center",
    className: "db_swipe_actions text-center",
    Cell: cellProps => {
      const currentUserId = parseInt(localStorage.getItem("auth_id"))
      const staffUserId = parseInt(cellProps?.row?.original?.user_id)
      const isRestricted = RESTRICTED_STAFF_IDS.includes(staffUserId)
      const canApprove = !isRestricted || currentUserId === DESIGNATED_APPROVER_ID
      return (
        <div className="d-flex justify-content-center">
          {canApprove ? (
            <>
              <a
                className="btn btn-sm btn-outline-primary me-1"
                title="Approve"
                onClick={() =>
                  onApprove(
                    cellProps?.row?.original?.leave_type,
                    cellProps?.row?.original?.id,
                    cellProps.row.original
                  )
                }
              >
                <i className="bi bi-check-lg icon-center"></i>
              </a>
              <a
                className="btn btn-sm btn-outline-danger me-1"
                title="Disapprove"
                onClick={() =>
                  onDisapporve(
                    cellProps?.row?.original?.leave_type,
                    cellProps?.row?.original?.id
                  )
                }
              >
                <i className="dripicons-cross icon-center"></i>
              </a>
            </>
          ) : (
            <span className="text-muted">-</span>
          )}
        </div>
      )
    },
  },
]

export const suppprtColumns = onReply => [
  {
    Header: "ID",
    accessor: "id",
    title: "ID",
    isInfoIcon: false,
    isShortIcon: true,
    className: "s_id",
    Cell: cellProps => {
      let priorty
      if (cellProps.row.original?.priority == "high") {
        priorty = <i title="High priority" className="bx bxs-hot icon-hot"></i>
      } else if (cellProps.row.original?.priority == "medium") {
        priorty = (
          <i title="Medium priority" className="bx bxs-flame icon-flame"></i>
        )
      } else if (cellProps.row.original?.priority == "low") {
        priorty = <i title="Low priority" className="bx bxs-sun icon-sun"></i>
      }
      return (
        <div className="d-flex gap-1">
          {priorty} {cellProps.row.original?.id}
        </div>
      )
    },
  },
  {
    Header: "Assign",
    title: "assign",
    accessor: "assign_name",
    isInfoIcon: false,
    isShortIcon: true,
    className: "assigneds_name_box",
    Cell: cellProps => {
      return (
        <div className="text-center d-flex gap-1  justify-content-center align-items-center">
          <img
            src={sideImg}
            alt=""
            className="img-fluid assignee-img"
            title="User Image"
          />
          <img
            src={bug}
            alt=""
            className="img-fluid assignee-img"
            title="Bug"
          />
        </div>
      )
    },
  },
  {
    Header: "Project",
    title: "Customer",
    accessor: "customer",
    isInfoIcon: false,
    isShortIcon: true,
    className: "scustomer_box",
  },
  {
    Header: "Title",
    title: "Task Name",
    accessor: "task_name",
    isInfoIcon: false,
    isShortIcon: true,
    className: "stask_name_box",
  },

  {
    Header: "Status",
    title: "Status",
    accessor: "status_col",
    isInfoIcon: false,
    isShortIcon: true,
    className: "sstatus_box",
    Cell: cellProps => {
      return (
        <div className="custom-select-wrapper" style={{ width: "100%" }}>
          <select
            className={`form-select custom-select`}
            onSelect={e => setSelectStatus(e.target.value)}
          >
            <option value="" className="">
              - Select -
            </option>
            <option value="notanswered" className="" selected>
              Not Answered
            </option>
            <option value="open" className="">
              Open
            </option>
            <option value="inprogress" className="">
              In Progress
            </option>
            <option value="answered" className="">
              Answered
            </option>
            <option value="onhol`d" className="">
              on Hold
            </option>
            <option value="Closed" className="">
              Closed
            </option>
          </select>
        </div>
      )
    },
  },
  {
    Header: "Created At",
    title: "created at",
    accessor: "created_at",
    isInfoIcon: false,
    isShortIcon: true,
    className: "screated_at_col-box",
  },
  {
    Header: "Last Reply",
    title: "Last Reply",
    accessor: "last_reply_col",
    isInfoIcon: false,
    isShortIcon: true,
    className: "slast_reply_col-box ",
  },
  {
    Header: "Action",
    accessor: "action",
    className: "msupport_action",
    Cell: cellProps => {
      return (
        <div className="d-flex justify-content-center">
          <a
            className="btn btn-sm btn-outline-success me-1"
            title="Start / Stop Timer"
          >
            <i className="fa fa-stopwatch"></i>
          </a>
          <a
            className="btn btn-sm btn-outline-secondary me-1"
            title="Start / Stop Timer"
            onClick={() => onReply()}
          >
            <i className="bi bi-reply-fill"></i>
          </a>
        </div>
      )
    },
  },
]

export const projectsColumnsDash = () => [
  {
    Header: "ID",
    accessor: "id",
    title: "ID",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center project_id",
  },
  {
    Header: "Project Name",
    title: "Project Name",
    accessor: "project_name",
    isInfoIcon: false,
    isShortIcon: true,
    className: "project_name_box",
  },
  {
    Header: "Customer",
    title: "Customer",
    accessor: "customer",
    isInfoIcon: false,
    isShortIcon: true,
    className: "customer_name_box",
  },
  {
    Header: "Start Date",
    title: "Start Date",
    accessor: "start_date",
    isInfoIcon: false,
    isShortIcon: true,
    className: "start_date_box text-center",
    Cell: cellProps => {
      return (
        <>{moment(cellProps.row.original.startdate).format("DD-MM-YYYY")}</>
      )
    },
  },
  {
    Header: "Due Date",
    accessor: "enddate",
    isInfoIcon: false,
    isShortIcon: true,
    className: "due_date_box text-center",
    Cell: cellProps => {
      return (
        <>
          {cellProps.row.original.enddate
            ? moment(cellProps.row.original.enddate).format("DD-MM-YYYY")
            : "-"}
        </>
      )
    },
  },
  {
    Header: "P.W.D",
    title: "Pending Working Days",
    accessor: "pwd",
    isInfoIcon: false,
    isShortIcon: true,
    className: "pwd_box text-center",
  },
  {
    Header: "Days",
    title: "Last Updated Days",
    accessor: "days",
    isInfoIcon: false,
    isShortIcon: true,
    className: "projects_days_box text-center",
  },
  {
    Header: "Status",
    title: "Status",
    accessor: "status",
    isInfoIcon: false,
    isShortIcon: true,
    className: "project_status_box text-center",
    Cell: cellProps => {
      return (
        <div className="" style={{ width: "100%" }}>
          {
            projectStatus?.find(
              obj => obj?.value == cellProps.row.original.status
            )?.label
          }
        </div>
      )
    },
  },
  {
    Header: "D.I.D",
    title: "Days Remaining For Project Delivery",
    accessor: "did_col",
    isInfoIcon: false,
    isShortIcon: true,
    className: "did_box text-center",
    Cell: cellProps => {
      const startDate = moment()
      const deliveryDateBefore = moment(
        cellProps.row.original.deliverydatebefore
      )
      const differenceInDays = deliveryDateBefore?.diff(startDate, "days")
      return <>{differenceInDays ? differenceInDays : ""}</>
    },
  },
]

export const approvalTimerColumns = onApprove => [
  {
    Header: "ID",
    accessor: "timer_id",
    className: "db_swipe_id",
    isShortIcon: true,
  },
  {
    Header: "Task Name",
    accessor: "db_swipe_name",
    className: "col-3",
    isShortIcon: true,
    Cell: cellProps => {
      const name = cellProps?.row?.original
      return (
        <div className="d-flex justify-content-start gap-1 db_swipe_name_box align-items-center">
          {name?.avatar ? (
            <img
              className="user_img_da img-fluid cursor-pointer me-2"
              src={`${configure.imgUrl}/${name?.avatar}`}
              alt="Image"
            />
          ) : null}
          <span title={name?.project_name}>
            {/* {trimProjectName(name?.project_name)} */}
          </span>{" "}
          - {name?.title}
        </div>
      )
    },
  },
  {
    Header: "Reason",
    accessor: "db_swipe_daste",
    className: "col-3",
    isShortIcon: true,
    Cell: cellProps => {
      return (
        <div>
          {
            resaonOtption?.find(
              obj => obj?.value == cellProps?.row?.original?.reason
            )?.label
          }
        </div>
      )
    },
  },
  {
    Header: "Actual Time",
    accessor: "ostart",
    className: "db_swipe_actions",
    isShortIcon: true,
    Cell: cellProps => {
      return (
        <div>
          {cellProps?.row?.original?.status == 3
            ? "0 hrs 0 min"
            : calculateTimeDifference(
              cellProps?.row?.original?.ostart,
              cellProps?.row?.original?.oend
            )}
        </div>
      )
    },
  },
  {
    Header: "Updated Time",
    accessor: "oend",
    className: "db_swipe_actions",
    isShortIcon: true,
    Cell: cellProps => {
      return (
        <div>
          {calculateTimeDifference(
            cellProps?.row?.original?.nstart,
            cellProps?.row?.original?.nend
          )}
        </div>
      )
    },
  },
  {
    Header: "Action",
    accessor: "db_swipe_actions text-center",
    className: "db_swipe_actions text-center",
    Cell: cellProps => {
      return (
        <div className="d-flex justify-content-center">
          <a
            className="btn btn-sm btn-outline-primary me-1"
            title="Approve"
            onClick={() =>
              onApprove(
                1,
                cellProps?.row?.original?.timer_id,
                cellProps?.row?.original?.status
              )
            }
          >
            <i className="bi bi-check-lg icon-center"></i>
          </a>
          <a
            className="btn btn-sm btn-outline-danger me-1"
            title="Disapprove"
            onClick={() =>
              onApprove(
                2,
                cellProps?.row?.original?.timer_id,
                cellProps?.row?.original?.status
              )
            }
          >
            <i className="dripicons-cross icon-center"></i>
          </a>
        </div>
      )
    },
  },
]

export const approvalDelayColumns = onDelayApprove => [
  {
    Header: "ID",
    accessor: "id",
    className: "db_swipe_id",
    isShortIcon: true,
  },
  {
    Header: "Assigned Member",
    className: "col-2",
    isShortIcon: true,
    Cell: cellProps => {
      const name = cellProps?.row?.original
      return (
        <div className="d-flex justify-content-start gap-3 db_swipe_name_box align-items-center">
          {name?.assign_user?.avatar ? (
            <img
              className="user_img_da img-fluid cursor-pointer me-2"
              src={`${configure.imgUrl}/${name?.assign_user?.avatar}`}
              alt="Image"
            />
          ) : (
            <div
              className="defualt-img event-timeline-dot connected-dot"
              title={name?.assign_user?.alias_name}
            >
              {getInitials(name?.assign_user?.alias_name || "Z")}
            </div>
          )}
          <span>{name?.assign_user?.alias_name || "--"}</span>
        </div>
      )
    },
  },
  {
    Header: "Project",
    accessor: "project_name",
    className: "col-2",
    isShortIcon: true,
  },
  {
    Header: "Task Name",
    accessor: "title",
    className: "col-2",
    isShortIcon: true,
  },

  {
    Header: "Delay Reason",
    accessor: "delay_reason",
    className: "col-3",
    isShortIcon: true,
  },
  {
    Header: "Est. Time",
    accessor: "estimation_days",
    className: "db_swipe_actions",
    isShortIcon: true,
  },
  {
    Header: "Used Time",
    accessor: "time_used",
    className: "db_swipe_actions",
    isShortIcon: true,
  },
  {
    Header: "Action",
    accessor: "db_swipe_actions",
    className: "db_swipe_actions text-center",
    Cell: cellProps => {
      return (
        <div className="d-flex justify-content-center">
          <a
            className="btn btn-sm btn-outline-primary me-1"
            title="Approve"
            onClick={() => onDelayApprove(cellProps?.row?.original?.id, 1)}
          >
            <i className="bi bi-check-lg icon-center"></i>
          </a>
          <a
            className="btn btn-sm btn-outline-danger me-1"
            title="Disapprove"
            onClick={() => onDelayApprove(cellProps?.row?.original?.id, 2)}
          >
            <i className="dripicons-cross icon-center"></i>
          </a>
        </div>
      )
    },
  },
]

export const delayTasksColumns = (tab, tabs) => [
  {
    Header: "ID",
    accessor: "id",
    className: "db_swipe_id",
    isShortIcon: true,
  },
  {
    Header: "KAM",
    accessor: "delay_approval",
    isShortIcon: true,
    Cell: cellProps => {
      const {
        delay_approval = 0,
        status = 0,
        kam_user = "",
      } = cellProps.row.original
      let text = ""

      if (tab === tabs[1]) {
        text = kam_user?.alias_name || "--"
      } else {
        switch (tab === tabs[0] ? delay_approval : status) {
          case 0:
            text = (
              <i className="fas fa-exclamation-triangle text-warning fs-5"></i>
            )
            break
          case 1:
            text = <i className="fas fa-check-circle text-success fs-5"></i>
            break
          case 2:
            text = <i className="fas fa-times-circle text-danger fs-5"></i>
            break
          default:
            text = (
              <i className="fas fa-exclamation-triangle text-warning fs-5"></i>
            )
        }
      }

      return (
        <div className="profileImg-box d-flex align-items-center">
          {kam_user.avatar ? (
            <img
              src={`${configure.imgUrl}${kam_user.avatar}`}
              alt=""
              className="assigned-img  me-3"
              height="30"
              width="30"
              title={kam_user?.alias_name}
            />
          ) : (
            <div
              className="defualt-img me-2"
              title={kam_user?.alias_name || "Z"}
            >
              {getInitials(kam_user?.alias_name || "Z")}
            </div>
          )}

          {text}
        </div>
      )
    },
  },
  // ...(tab === tabs[0] || tab === tabs[1]
  //   ? [
  //       {
  //         Header: "KAM",
  //         accessor: "delay_approval",
  //         isShortIcon: true,
  //         Cell: cellProps => {
  //           const { delay_approval = 0, kam_user = "" } = cellProps.row.original
  //           let text = ""

  //           if (tab === tabs[0]) {
  //             switch (delay_approval) {
  //               case 0:
  //                 text = (
  //                   <i className="fas fa-exclamation-triangle text-warning fs-5"></i>
  //                 )
  //                 break
  //               case 1:
  //                 text = (
  //                   <i className="fas fa-check-circle text-success fs-5"></i>
  //                 )
  //                 break
  //               case 2:
  //                 text = (
  //                   <i className="fas fa-times-circle text-danger fs-5"></i>
  //                 )
  //                 break
  //               default:
  //                 text = (
  //                   <i className="fas fa-exclamation-triangle text-warning fs-5"></i>
  //                 )
  //             }
  //           } else if (tab === tabs[1]) {
  //             text = kam_user?.alias_name || "--"
  //           }

  //           return (
  //             <div className="profileImg-box d-flex align-items-center">
  //               {kam_user.avatar ? (
  //                 <img
  //                   src={`${configure.imgUrl}${kam_user.avatar}`}
  //                   alt=""
  //                   className="assigned-img  me-3"
  //                   height="30"
  //                   width="30"
  //                   title={kam_user?.alias_name}
  //                 />
  //               ) : (
  //                 <div
  //                   className="defualt-img me-2"
  //                   title={kam_user?.alias_name || "Z"}
  //                 >
  //                   {getInitials(kam_user?.alias_name || "Z")}
  //                 </div>
  //               )}

  //               {text}
  //             </div>
  //           )
  //         },
  //       },
  //     ]
  //   : []),
  {
    Header: "Project",
    accessor: "project_name",
    isShortIcon: true,
  },
  {
    Header: "Task",
    accessor: "title",
    isShortIcon: true,
  },
  ...(tab === tabs[0] || tab === tabs[1]
    ? [
      {
        Header: "Assigned",
        accessor: "assign_user.alias_name",
        className: "col-2",
        isShortIcon: true,
      },
      {
        Header: "Est. Time",
        accessor: "estimation_days",
        className: "",
        isShortIcon: true,
      },
    ]
    : []),

  ...(tab === tabs[0] || tab === tabs[2]
    ? [
      {
        Header: "Used Time",
        accessor: "time_used",
        isShortIcon: true,
      },
    ]
    : []),

  {
    Header:
      tab === tabs[0]
        ? "Delay Reason"
        : tab === tabs[1]
          ? "Reason For Add"
          : "Reason",
    accessor:
      tab === tabs[0]
        ? "delay_reason"
        : tab === tabs[1]
          ? "extra_task_reason"
          : "reason",
    className: "col-2",
    isShortIcon: true,
  },
]

// =======================================
const safeJSONParse = (value, fallback = null) => {
  try {
    if (!value || typeof value !== "string") return fallback
    const parsed = JSON.parse(value)
    return parsed ?? fallback
  } catch (e) {
    console.error("JSON parse failed:", value, e)
    return fallback
  }
}

export const NewLeadsDashboardColumns = (
  onOpenLead,
  removeFromList,
  onAddTask
) => [
    {
      Header: "Id",
      accessor: "id",
      isInfoIcon: false,
      className: "text-center id-col tab-1",
    },
    {
      Header: "Company Name",
      accessor: "company",
      isInfoIcon: false,
      className: " customer-col tab-4",
    },
    {
      Header: "Name",
      accessor: "name",
      grow: false,
      className: "prf_invoice_box text-center tab-3",
      isInfoIcon: true,
      Cell: cellProps => {
        const personal = safeJSONParse(cellProps.row.original.person_details, [])

        const personName =
          Array.isArray(personal) && personal.length > 0
            ? personal[0]?.person_name
            : "-"

        return <div>{personName || "-"}</div>
      },
    },

    {
      Header: "Email ID",
      accessor: "email",
      isInfoIcon: true,
      className: "prf_invoice_box tab-3",
      Cell: cellProps => {
        const alldata = cellProps.row.original
        const personal = safeJSONParse(alldata.person_details, [])

        const email = personal?.[0]?.person_email || alldata?.email || "-"

        return <div>{email}</div>
      },
    },
    {
      Header: "Phone",
      accessor: "phone",
      isInfoIcon: true,
      className: "text-center",
      Cell: cellProps => {
        const alldata = cellProps.row.original
        const personal = safeJSONParse(alldata.person_details, [])

        const phone = personal?.[0]?.person_phone || alldata?.phonenumber || "-"

        return <div>{phone}</div>
      },
    },
    {
      Header: "Source",
      accessor: "source",
      isInfoIcon: false,
      className: " text-center",
    },
    {
      Header: "Created At",
      accessor: "created_at",
      isInfoIcon: false,
      className: "text-center",
      Cell: cellProps => {
        return (
          <div>
            {moment(cellProps?.row?.original?.created_at).format("DD-MM-YYYY")}
          </div>
        )
      },
    },
    {
      Header: "Action",
      accessor: "action",
      className: "activity-action",
      Cell: cellProps => {
        return (
          <>
            <div className="d-flex justify-content-center">
              <a
                className="btn btn-sm btn-outline-secondary me-1"
                title="View Activity"
                onClick={() => onOpenLead(cellProps?.row?.original)}
              >
                <i className="fas fa-info "></i>
              </a>
              <a
                className="btn btn-sm btn-outline-primary me-1"
                title="Approve"
                onClick={() => removeFromList(cellProps?.row?.original?.id)}
              >
                <i className="bi bi-check-lg icon-center"></i>
              </a>
              {/* <a title="Add Task" className="btn btn-sm btn-outline-secondary me-1 " onClick={() => onAddTask(cellProps?.row?.original?.id)} >
                            <i className="fas fa-clipboard-list"></i>
                        </a> */}
            </div>
          </>
        )
      },
    },
  ]

export const tenderFollowups = (
  handleChangeTenderStatus,
  onManagePlan,
  onAddTenderTask
) => [
    // --------------------------------- ID Column ---------------------------------
    {
      Header: "Id",
      accessor: "id",
      isInfoIcon: false,
      isShortIcon: true,
      className: "dg_id",
      Cell: cellProps => {
        const row = cellProps.row.original

        // Local status state (for plan_day)
        const [status, setStatus] = useState(row.plan_day)

        useEffect(() => {
          setStatus(row.plan_day)
        }, [row.plan_day])

        return (
          <div className="d-flex justify-content-center align-items-center gap-2">
            {/* ID */}
            <span>{row.id}</span>
          </div>
        )
      },
    },
    // --------------------------------- STATUS Column ---------------------------------
    {
      Header: "Status",
      accessor: "status",
      isInfoIcon: false,
      isShortIcon: true,
      className: "dg-com-status text-center",
      Cell: cellProps => {
        const row = cellProps.row.original

        const [isChecked, setIsChecked] = useState(row.status === 1)

        const handleCheckboxChange = async e => {
          const checked = e.target.checked
          setIsChecked(checked)

          const userConfirmed = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to change the status?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, change it!",
            cancelButtonText: "No, cancel",
          })

          if (userConfirmed.isConfirmed) {
            handleChangeTenderStatus(row.id)
          } else {
            setIsChecked(!checked)
          }
        }

        // ------------------- Date Format --------------------
        const formattedDate = moment(row.date).format("DD-MM-YYYY")
        console.log(
          "avatar: ",
          row?.user_info?.avatar,
          "alias: ",
          row?.user_info?.alias_name
        )

        return (
          <div className="d-flex align-items-center gap-3 justify-content-center">
            {/* Date */}
            <span className="">{formattedDate}</span>
            {/* Avatar */}
            {row?.user_info?.avatar ? (
              <img
                src={`${configure.imgUrl}${row?.user_info?.avatar}`}
                alt="avatar"
                className="img-fluid assignee-img"
                title={row?.user_info?.alias_name || "z"}
              />
            ) : (
              <div
                className="defualt-img"
                title={row?.user_info?.alias_name || "z"}
              >
                {getInitials(row?.user_info?.alias_name || "z")}
              </div>
            )}

            {/* Checkbox */}
            {/* <input
            type="checkbox"
            className="form-check-input custom-checkbox  mt-2im general-status"
            checked={isChecked}
            onChange={handleCheckboxChange}
          /> */}

            <div
              className="custom-status-box"
              onClick={() => {
                // toggle only if not completed permanently
                handleCheckboxChange(
                  { target: { checked: !isChecked } },
                  cellProps.row.original.id
                )
              }}
            >
              <div className={`status-ui ${isChecked ? "checked" : "unchecked"}`}>
                {isChecked && <i className="fas fa-check"></i>}
              </div>
            </div>
          </div>
        )
      },
    },

    // --------------------------------- DESCRIPTION Column ---------------------------------
    {
      Header: "Description",
      accessor: "description",
      isInfoIcon: false,
      isShortIcon: true,
      className: "dg_task_name",
      Cell: cellProps => {
        return (
          <span>
            <span className="fw-bold">
              {cellProps.row.original?.tender_details?.name}
            </span>
            <span> - {cellProps.row.original?.description}</span>
          </span>
        )
      },
    },

    // --------------------------------- ACTION Column ---------------------------------
    {
      Header: "Action",
      accessor: "action",
      className: "activity-action",
      Cell: cellProps => {
        return (
          <div className="d-flex">
            <Link
              title="View Tender"
              className="btn btn-sm btn-outline-secondary me-1"
              to={`${configure.appUrl}marketing/edit-tender/${cellProps.row.original?.tender_id}`}
            >
              <i className="fas fa-arrow-right"></i>
            </Link>

            <a
              title="Add Task"
              className="btn btn-sm btn-outline-secondary me-1"
              onClick={() => onAddTenderTask(cellProps.row.original)}
            >
              <i className="fas fa-clipboard-list"></i>
            </a>
          </div>
        )
      },
    },
  ]
